import { Icon } from '@chakra-ui/react'

export const CalendarIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_4411_85992)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66673 0.733398C4.9981 0.733398 5.26673 1.00203 5.26673 1.3334V2.63816H10.7334V1.3334C10.7334 1.00203 11.002 0.733398 11.3334 0.733398C11.6648 0.733398 11.9334 1.00203 11.9334 1.3334V2.63816H13.3334C14.4011 2.63816 15.2667 3.50374 15.2667 4.57149V13.3334C15.2667 14.4011 14.4011 15.2667 13.3334 15.2667H2.66673C1.59898 15.2667 0.733398 14.4011 0.733398 13.3334V4.57149C0.733398 3.50374 1.59898 2.63816 2.66673 2.63816H4.06673V1.3334C4.06673 1.00203 4.33536 0.733398 4.66673 0.733398ZM2.66673 3.83816C2.26172 3.83816 1.9334 4.16648 1.9334 4.57149V5.91858H14.0667V4.57149C14.0667 4.16648 13.7384 3.83816 13.3334 3.83816H2.66673ZM14.0667 7.11858H1.9334V13.3334C1.9334 13.7384 2.26172 14.0667 2.66673 14.0667H13.3334C13.7384 14.0667 14.0667 13.7384 14.0667 13.3334V7.11858Z" fill="#58585B" />
        </g>
        <defs>
            <clipPath id="clip0_4411_85992">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>

)

